import React, { useCallback, useState } from 'react';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { validatePostcode, findAddresses, clearAddresses } from 'redux/actions/consultation/answer';
import { consultationSelector } from 'redux/selectors/consultation';
import { ColumnDiv } from 'styles/elements/div';
import { Postcode } from './postcode';
import { AddressLookup } from './addressLookup';

export function Address({ onSelectAddress, onUpdatePostcode, postcode, questionText, onUpdateCity, isReadOnly, postcodeAnswerId }) {
  const mapState = useCallback(state => consultationSelector(state), []);
  const {
    postcodeAPIResults,
    addresses,
    addressesCity,
    validationErrors,
  } = useMappedState(mapState);

  const [isPostcodeOk, setIsPostcodeOk] = useState(false);

  // actions to update value
  const dispatch = useDispatch();
  return (
    <ColumnDiv>
      <Postcode
        validPostcodes={postcodeAPIResults}
        postcode={postcode}
        questionText={questionText}
        validatePostcode={postcodeToValidate => dispatch(validatePostcode(postcodeToValidate))}
        updatePostcode={onUpdatePostcode}
        findAddresses={postcodeToLookup => dispatch(findAddresses(postcodeToLookup))}
        isPostcodeOk={isPostcodeOk}
        setIsPostcodeOk={setIsPostcodeOk}
        validationErrors={validationErrors}
        isReadOnly={isReadOnly}
        postcodeAnswerId={postcodeAnswerId}
      />
      <AddressLookup
        addresses={addresses}
        onSelectAddress={onSelectAddress}
        isPostcodeOk={isPostcodeOk}
        clearAddresses={() => dispatch(clearAddresses())}
        autofillCity={onUpdateCity}
        addressesCity={addressesCity}
      />
    </ColumnDiv>
  );
}
